// import React from 'react'
// import { useNavigate } from 'react-router-dom';
// const CTASection = ({ item }) => {
//     const navigate = useNavigate();
//     return (
//         <div className='bg-[#F7F8FF] w-full p-4 mb-5'>
//             <div
//                 key={item.id}
//                 className={`flex md:flex-row overflow-hidden gap-2 rounded-2xl w-full max-w-4xl mx-auto bg-[#F7F8FF]`}
//             >
//                 {/* Left: Image (40% width) */}
//                 <div
//                     className={`w-full h-35 md:w-[35%]`}
//                 >
//                     <img
//                         src={item.img}
//                         alt={item.title}
//                         className="w-full h-full object-cover rounded-xl"
//                     />
//                 </div>
//                 <div
//                     className={`relative w-full  bg-[#F7F8FF] p-4 flex flex-col `}
//                 >
//                     <div className="relative z-10">
//                         <h2
//                             className={`text-[28px] font-[500] text-[var(--primary-color)] mb-3 lg:mt-2`}
//                         >
//                             {item.title}
//                         </h2>
//                         <p className="text-[var(--primary-color)] font-light leading-relaxed text-[15px]">
//                             {item?.desc}
//                         </p>
//                          {item?.cta?.primary && (
//                         <button
//                             onClick={() => navigate(item.cta.primary.href)}
//                             className="btn-primary mt-4"
//                         >
//                             {item.cta.primary.label}
//                         </button>
//                     )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default CTASection
import React from 'react'
import { useNavigate } from 'react-router-dom';

const CTASection = ({ item }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full ava-card-bg px-4 py-6 md:py-10">
      <div className="flex flex-col md:flex-row gap-4 md:gap-6 max-w-5xl mx-auto rounded-2xl overflow-hidden">

        {/* Image */}
        <div className="w-full md:w-[35%] h-48 sm:h-56 md:h-auto">
          <img
            src={item.img}
            alt={item.title}
            className="w-full h-full object-cover rounded-xl md:rounded-2xl"
          />
        </div>

        {/* Content */}
        <div className="flex flex-col justify-center p-2 md:p-4 flex-1">

          {/* Heading */}
          <h2 className=" ava-heading-md  mb-2 md:mb-3">
            {item.title}
          </h2>

          {/* Description */}
          <p className=" ava-text-body  ">
            {item?.desc}
          </p>

          {/* CTA */}
          {item?.cta?.primary && (
            <button
              onClick={() => navigate(item.cta.primary.href)}
              className="btn-primary mt-4 w-fit"
            >
              {item.cta.primary.label}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default CTASection;